<ix-modal-header>
  {{ 'battery_pass.import.header' | translate }}
</ix-modal-header>
<ix-modal-content>
  @if (selectedIndex === SEARCH_ASSETS_TAB) {
    <div class="received-attributes-wrapper">
      <form [formGroup]="cxSearchForm">
        <div>
          <!-- Provider -->
          <ix-select
            [label]="'battery_pass.import.fields.provider_label' | translate"
            (valueChange)="onProviderChange($event)"
            [i18nPlaceholder]="
              'battery_pass.import.fields.provider_label' | translate
            "
            [i18nSelectListHeader]="'general.select_list_header' | translate"
            class="w-100"
            formControlName="assignedProviders"
            >
            @for (provider of providers; track provider) {
              <ix-select-item
                [label]="provider"
                [value]="provider"
              ></ix-select-item>
            }
          </ix-select>
          @if (
            cxSearchForm.controls['assignedProviders'].invalid &&
            cxSearchForm.controls['assignedProviders'].dirty
            ) {
            <div
              class="error-msg"
              >
              {{ 'battery_pass.import.fields.provider_invalid_msg' | translate }}
            </div>
          }
          <!-- Catena-X model -->
          <ix-select
            [label]="'battery_pass.import.fields.cx_model_label' | translate"
            (valueChange)="onSchemaChange($event)"
            [i18nPlaceholder]="
              'battery_pass.import.fields.cx_model_label' | translate
            "
            [i18nSelectListHeader]="'general.select_list_header' | translate"
            [value]="availableSchemas[0].value"
            class="w-100"
            formControlName="assignedSchema"
            >
            @for (schema of availableSchemas; track schema) {
              <ix-select-item
                [label]="schema.label"
                [value]="schema.value"
              ></ix-select-item>
            }
          </ix-select>
          @if (
            cxSearchForm.controls['assignedSchema'].invalid &&
            cxSearchForm.controls['assignedSchema'].dirty
            ) {
            <div
              class="error-msg"
              >
              {{ 'battery_pass.import.fields.cx_model_invalid_msg' | translate }}
            </div>
          }
          <!-- Catena-X Passport ID -->
          <ix-input
            [label]="'battery_pass.import.fields.asset_id_label' | translate"
            [ngClass]="{'ix-invalid': cxSearchForm.controls['assetId'].invalid}"
            [placeholder]="'battery_pass.import.fields.asset_id_label' | translate"
            class="w-100"
            formControlName="assetId"
            id="cxSearchAssetIdInput"
            />
            @if (
              cxSearchForm.controls['assetId'].invalid &&
              cxSearchForm.controls['assetId'].dirty
              ) {
              <div
                class="error-msg"
                >
                {{ 'battery_pass.import.fields.asset_id_invalid_msg' | translate }}
              </div>
            }
          </div>
        </form>
        @if (searchErrors && searchErrors.length > 0) {
          <ix-event-list
            class="mt-4"
            >
            @for (message of searchErrors; track message) {
              <ix-event-list-item
                class="no-pointer-event"
                itemColor="--theme-color-alarm"
                >{{ message }}
              </ix-event-list-item>
            }
          </ix-event-list>
        }
      </div>
    }

    @if (selectedIndex === COMPARE_ASSETS_TAB) {
      <div class="d-flex justify-content-around">
        <div class="expected-attributes-wrapper w-50">
          <ix-typography class="mb-2 compare-headline p-2" format="display-sm"
            >{{ 'battery_pass.import.expected_attributes_header' | translate }}
          </ix-typography>
          <div class="list-wrapper overflow-scroll mt-2">
            <ix-event-list>
              @for (data of expectedData; track data) {
                <ix-event-list-item
              [itemColor]="
                data.found ? '--theme-color-success' : '--theme-color-alarm'
              "
                  disabled="true"
                  >
                  <ix-icon
                    [name]="data.found ? 'check' : 'warning'"
                    class="me-2"
                  ></ix-icon>
                  {{ 'battery_pass.' + data.key + '_label' | translate }}
                </ix-event-list-item>
              }
            </ix-event-list>
          </div>
        </div>
        <div class="received-attributes-wrapper ps-2 w-50">
          <ix-typography
            class="mb-2 compare-headline p-2"
            format="display-sm"
          title="{{
            'battery_pass.import.received_attributes_header' | translate
          }} ({{ selectedSchema }})"
            >{{
            'battery_pass.import.received_attributes_header' | translate
            }}
            ({{ selectedSchema }})
          </ix-typography>
          <div class="list-wrapper overflow-scroll mt-2">
            @if (!importSearchLoading) {
              <ix-event-list>
                @for (data of receivedData; track data) {
                  <ix-event-list-item
              [itemColor]="
                data.found ? '--theme-color-success' : '--theme-color-neutral'
              "
                    disabled="true"
                    >
                    @if (data.found) {
                      <ix-icon class="me-2" name="check"></ix-icon>
                    }
                    {{ 'battery_pass.' + data.key + '_label' | translate }}
                  </ix-event-list-item>
                }
              </ix-event-list>
            }
            @if (importSearchLoading) {
              <div
                class="d-flex justify-content-center mt-3"
                >
                <ix-spinner></ix-spinner>
              </div>
            }
            @if (!importSearchLoading && receivedData.length === 0) {
              <ix-empty-state
                (actionClick)="onSelectIndexClick(SEARCH_ASSETS_TAB)"
                action="{{ 'battery_pass.import.load_asset_label' | translate }}"
                class="mt-2"
                header="{{ 'battery_pass.import.no_asset_available' | translate }}"
                icon="reload"
            subHeader="{{
              'battery_pass.import.search_for_asset_first' | translate
            }}"
              ></ix-empty-state>
            }
          </div>
        </div>
      </div>
    }

    @if (selectedIndex === IMPORT_ASSETS_TAB) {
      <div class="d-flex justify-content-center">
        <div class="received-attributes-wrapper px-5">
          @if (!importLoading && hasImportStarted && isImportSuccessful) {
            <div
              class="list-wrapper overflow-scroll mt-2"
              >
              <ix-typography class="mb-2" format="display-xs">
                {{ 'battery_pass.import.imported_values_header' | translate }}
              </ix-typography>
              <ix-event-list>
                @for (data of expectedData; track data) {
                  @if (data.found) {
                    <ix-event-list-item
                [itemColor]="
                  data.found ? '--theme-color-success' : '--theme-color-alarm'
                "
                      disabled="true"
                      >
                      <ix-icon
                        [name]="data.found ? 'check' : 'warning'"
                        class="me-2"
                      ></ix-icon>
                      {{ 'battery_pass.' + data.key + '_label' | translate }}
                    </ix-event-list-item>
                  }
                }
              </ix-event-list>
              <ix-typography class="mb-2" format="display-xs">
                {{ 'battery_pass.import.not_imported_values_header' | translate }}
              </ix-typography>
              <ix-event-list>
                @for (data of expectedData; track data) {
                  @if (!data.found) {
                    <ix-event-list-item
                [itemColor]="
                  data.found ? '--theme-color-success' : '--theme-color-alarm'
                "
                      disabled="true"
                      >
                      <ix-icon
                        [name]="data.found ? 'check' : 'warning'"
                        class="me-2"
                      ></ix-icon>
                      {{ 'battery_pass.' + data.key + '_label' | translate }}
                    </ix-event-list-item>
                  }
                }
              </ix-event-list>
            </div>
          }
          @if (!importLoading && !hasImportStarted) {
            <ix-empty-state
              (actionClick)="importAsset(model)"
              action="{{ 'battery_pass.import.button' | translate }}"
              class="mt-2"
              header="{{ 'battery_pass.import.import_not_started' | translate }}"
              icon="import"
          subHeader="{{
            'battery_pass.import.import_not_started_sublabel' | translate
          }}"
            ></ix-empty-state>
          }
          @if (importLoading) {
            <div class="d-flex justify-content-center mt-3">
              <ix-spinner></ix-spinner>
            </div>
          }
        </div>
        @if (importErrors && importErrors.length > 0) {
          <ix-event-list
            class="mt-4"
            >
            @for (message of importErrors; track message) {
              <ix-event-list-item
                class="no-pointer-event"
                itemColor="--theme-color-alarm"
                >{{ message }}
              </ix-event-list-item>
            }
          </ix-event-list>
        }
      </div>
    }

    <div class="d-flex justify-content-between align-items-center mt-3">
      <ix-button
        (click)="activeModal.close(true)"
        onkeypress=""
        variant="subtle-primary"
        >
        {{ 'general.close' | translate }}
      </ix-button>
      @if (cxSearchForm) {
        <ix-workflow-steps [selectedIndex]="selectedIndex - 1">
          <ix-workflow-step
            (click)="onSelectIndexClick(SEARCH_ASSETS_TAB)"
            [clickable]="true"
            [disabled]="false"
            [status]="receivedData.length > 0 ? 'success' : 'open'"
            class="pointer"
            id="modalImportWorkflowStepLoadAsset"
            onkeypress=""
            status="open"
            >{{ 'battery_pass.import.load_asset_label' | translate }}
          </ix-workflow-step>
          <ix-workflow-step
            (click)="onSelectIndexClick(COMPARE_ASSETS_TAB)"
            [clickable]="isIndexEnabled(COMPARE_ASSETS_TAB)"
            [disabled]="!isIndexEnabled(COMPARE_ASSETS_TAB)"
            [status]="selectedIndex === IMPORT_ASSETS_TAB ? 'success' : 'open'"
            class="pointer"
            id="modalImportWorkflowStepCompare"
            onkeypress=""
            status="open"
            >{{ 'battery_pass.import.compare_label' | translate }}
          </ix-workflow-step>
          @if (!isIndexEnabled(COMPARE_ASSETS_TAB)) {
            <ix-tooltip
              for="#modalImportWorkflowStepCompare"
              >
              {{ 'battery_pass.import.compare_label_tooltip' | translate }}
            </ix-tooltip>
          }
          <ix-workflow-step
            (click)="onSelectIndexClick(IMPORT_ASSETS_TAB)"
            [clickable]="isIndexEnabled(IMPORT_ASSETS_TAB)"
            [disabled]="!isIndexEnabled(IMPORT_ASSETS_TAB)"
            [status]="isImportSuccessful ? 'success' : 'open'"
            class="pointer"
            id="modalImportWorkflowStepImport"
            onkeypress=""
            status="open"
            >{{ 'battery_pass.import.button' | translate }}
          </ix-workflow-step>
          @if (!isIndexEnabled(IMPORT_ASSETS_TAB)) {
            <ix-tooltip
              for="#modalImportWorkflowStepImport"
              >
              {{ 'battery_pass.import.import_label_tooltip' | translate }}
            </ix-tooltip>
          }
        </ix-workflow-steps>
      }
      @if (
        (selectedIndex === COMPARE_ASSETS_TAB && receivedData.length === 0) ||
        selectedIndex === SEARCH_ASSETS_TAB
        ) {
        <ix-button
          (click)="onCxSearchClick()"
          [disabled]="cxSearchForm.invalid"
          [loading]="importSearchLoading"
          id="#modalImportSearchButton"
          onkeypress=""
          variant="primary"
          >{{ 'general.search' | translate }}
        </ix-button>
      }
      @if (selectedIndex !== SEARCH_ASSETS_TAB && receivedData.length > 0) {
        <ix-button
          (click)="importAsset(model)"
          [disabled]="isImportSuccessful || !isSomethingToMap"
          [loading]="importLoading"
          id="#modalImportImportButton"
          onkeypress=""
          variant="primary"
          >
          {{ 'battery_pass.import.button' | translate }}
        </ix-button>
      }
    </div>
  </ix-modal-content>
